import React from 'react'
import Scrollspy from 'react-scrollspy'

import './floating-navigation.css'

export const FloatingNavigation = ({ scrolling, contentSectionOne, contentSectionTwo, contentSectionThree }) => (
    <div className="component-floating-navigation">
        <div className={`component-floating-navigation__inner ${scrolling ? `scroll--fixed` : ''}`}>
            <Scrollspy items={[contentSectionOne, contentSectionTwo, contentSectionThree]} currentClassName="is-current">
                <a href={`#${contentSectionOne}`} className='block mb-15 bold text--dark decoration-none uppercase'>HERMÉTICA</a>
                <a href={`#${contentSectionTwo}`} className='block mb-15 bold text--dark decoration-none uppercase'>Spec Sheet</a>
                <a href={`#${contentSectionThree}`} className='block mb-15 bold text--dark decoration-none uppercase'>Learn More</a>
            </Scrollspy>
        </div>
    </div>
)